@if (!isHidden) {
  <div class="td-wb-menu-container">
    <!-- Mobile top menu -->
    <div class="td-wb-mobile-menu"
         role="region"
         [attr.aria-label]="'tdWb.menu.MOBILE_SIDE_MENU' | translate">
      <div class="td-wb-mobile-menu--left">
        <a #hamburgerMenu
           class="td-wb-mobile-menu__toggle td-wb-mobile-menu__toggle--side"
           [attr.aria-label]="'tdWb.menu.MOBILE_SIDE_MENU' | translate"
           href="#"
           [attr.aria-expanded]="isExpanded"
           (click)="open($event)">
          <td-wb-icon size="15x12"
                      iconId="hamburger" />
        </a>
        <a class="td-wb-mobile-menu__toggle td-wb-mobile-menu__toggle--home"
           [href]="logoUrl"
           [attr.aria-label]="logoLabelTranslationId | translate">
          <td-wb-icon iconId="logo--td"
                      size="29x26" />
        </a>
        <span class="td-wb-mobile-menu__title"
              [innerText]="menu?.applicationTitle[0]?.text ?? ''"></span>
      </div>
      <div class="td-wb-mobile-menu--right">
        <td-wb-menu-search-navigation />
      </div>
    </div>
    <td-wb-mobile-flyout-menu #flyoutMenu
                              [mainNav]="mobileFlyoutMenu"
                              (openedChange)="openedChange($event)"
                              tdWbDocumentNoScroll
                              #documentNoScroll="tdWbDocumentNoScroll">
      <td-wb-mobile-flyout-menu-nav #mobileFlyoutMenu
                                    tdWbMobileFlyoutMenuNavPan>
        <div class="td-wb-mobile-flyout-menu">
          <div class="td-wb-mobile-flyout-menu__header">
            <button class="td-wb-mobile-flyout-menu__header-close-button"
                    tabindex="0"
                    tdWbButton
                    tdWbButtonType="icon"
                    [attr.aria-label]="'tdWb.menu.CLOSE' | translate"
                    (click)="mobileFlyoutMenu.close()">
              <td-wb-icon iconId="close--small"
                          size="12"
                          class="td-wb-mobile-flyout-menu__header-close-icon" />
            </button>
            <ng-container *ngTemplateOutlet="hasProfilePermission() ? profileMenuTemplate : customizeMenuTemplate" />
            <div class="td-wb-mobile-flyout-menu__header-item-container"
                 role="navigation"
                 aria-labelledby="td-wb-aria-mobile-menu-client-name">
              @for (item of menu.mobileMenuHeaderToolbar; track item) {
                @if (item.id !== MESSAGE_MENU_ID) {
                  <a class="td-wb-mobile-flyout-menu__header-item"
                     [href]="item.href"
                     [attr.target]="item.target"
                     [attr.id]="'td-wb-top-navigation__content__item-' + item.id">
                    <td-wb-icon [iconId]="item.icon === undefined ? '' : item.icon?.cssClass"
                      size="24" />
                    <span class="td-wb-mobile-flyout-menu__header-item-text"
                          [innerText]="item.text"></span>
                  </a>
                }
                @if (item.id === MESSAGE_MENU_ID) {
                  <a class="td-wb-mobile-flyout-menu__header-item"
                     [href]="item.href"
                     [attr.target]="item.target"
                     [attr.id]="'td-wb-top-navigation__content__item-' + item.id">
                    <span class="td-wb-mobile-flyout-menu__header-item-envelope-icon">
                      <td-wb-icon size="24"
                                  iconId="email" />
                      <td-wb-messages-counter class="td-wb-mobile-flyout-menu__header-item-message-counter" />
                    </span>
                    <span class="td-wb-mobile-flyout-menu__header-item-text"
                          [innerText]="'Messages'"></span>
                  </a>
                }
              }
            </div>
          </div>
          <div class="td-wb-mobile-flyout-menu__content"
               role="navigation"
               aria-labelledby="td-wb-aria-client-name-title">
            @for (item of menu.mobileNavigation; track item) {
              @if (isMenuGroup(item)) {
                <a class="td-wb-mobile-flyout-menu__item"
                   aria-expanded="false"
                   href=""
                   (click)="openSub($event, item)"
                   [attr.id]="'td-wb-mobile-flyout-menu__content-item-' + item.id">
                  <span [innerHtml]="item.text"></span>
                  <td-wb-icon iconId="caret-right--small"
                    size="16" />
                </a>
              }
              @if (item.type === MenuItemType.SEPARATOR) {
                <td-wb-divider class="td-wb-mobile-flyout-menu-divider" />
              }
              @if (isLocalLink(item)) {
                <a class="td-wb-mobile-flyout-menu__item"
                   (click)="onMobileMenuClick(item)"
                   [href]="item.href"
                   [attr.target]="item.target"
                   [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                  <span [innerHtml]="item.text"></span>
                  @if (showNewBadge(item.href)) {
                    <td-wb-badge [text]="'tdWb.menu.badge.NEW' | translate"
                                 size="extra-small"
                                 colour="accent">
                    </td-wb-badge>
                  }
                </a>
              }
              @if (isExternalLink(item)) {
                <a class="td-wb-mobile-flyout-menu__item"
                   (click)="onMobileMenuClick(item)"
                   [href]="item.href"
                   [attr.target]="item.target"
                   [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                  <span [innerHtml]="item.text"></span>
                  <td-wb-icon class="td-wb-mobile-flyout-menu-icon--external-link"
                              iconId="new-page"
                              size="16" />
                </a>
              }
            }
          </div>
        </div>
      </td-wb-mobile-flyout-menu-nav>
      <td-wb-mobile-flyout-menu-nav #mobileFlyoutSubMenu>
        <ng-template let-menu>
          <div class="td-wb-mobile-flyout-menu">
            <div class="td-wb-mobile-flyout-submenu__header">
              <a class="td-wb-mobile-flyout-submenu__header-close-button"
                 aria-expanded="true"
                 href=""
                 (click)="closeSub($event)">
                <td-wb-icon iconId="caret-left--small"
                            size="8x13" />
                <span class="td-wb-mobile-flyout-submenu__header-text"
                      [innerHtml]="menu.text"></span>
              </a>
            </div>
            <div class="td-wb-mobile-flyout-menu__content--sub"
                 aria-labelledby="td-wb-aria-client-name-title">
              @for (item of menu.menu[0].item; track item) {
                @if (item.id === 'have-your-say') {
                  <div class="td-wb-mobile-flyout-menu__content-feedback-content">
                    <span class="td-wb-mobile-flyout-menu__content-feedback-text"
                          translate="tdWb.menu.IMPROVE_EXPERIENCE">
                    </span>
                    <ul class="td-wb-ul td-wb-ul--basic td-wb-mobile-flyout-menu__content-feedback-content--list">
                      <li class="td-wb-mobile-flyout-menu__content-feedback-text">
                        <span translate="tdWb.menu.FEEDBACK_TOPIC_1"></span>
                      </li>
                      <li class="td-wb-mobile-flyout-menu__content-feedback-text">
                        <span translate="tdWb.menu.FEEDBACK_TOPIC_2"></span>
                      </li>
                      <li class="td-wb-mobile-flyout-menu__content-feedback-text">
                        <span translate="tdWb.menu.FEEDBACK_TOPIC_3"></span>
                      </li>
                    </ul>
                    <button class="td-wb-mobile-flyout-menu__content-feedback-link"
                            tdWbButton
                            tdWbButtonType="secondary"
                            [tdWbHref]="item.href"
                            target="_blank">
                      <span [translate]="item.text"></span>
                    </button>
                  </div>
                } @else if(item.id === 'chat-with-live-agent') {
                  <!-- Check is split between 2 ifs to suppress this menu item if user should not be accessing chat -->
                  @if (showChat) {
                    <div class="td-wb-mobile-flyout-menu__chat">
                      <a tabindex="0"
                         role="button"
                         class="td-wb-mobile-flyout-menu__item--link"
                         (click)="openChat()"
                         (keydown.enter)="openChat()"
                         [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                        <span [innerHTML]="item.text"></span>
                      </a>
                    </div>
                  }
                }@else {
                  @if (isLocalLink(item)) {
                    <a class="td-wb-mobile-flyout-menu__item"
                       [href]="item.href"
                       [attr.target]="item.target"
                       [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                      <span [innerHTML]="item.text"></span>
                      @if (showNewBadge(item.href)) {
                        <td-wb-badge [text]="'tdWb.menu.badge.NEW' | translate"
                                     size="extra-small"
                                     colour="accent">
                        </td-wb-badge>
                      }
                    </a>
                  }
                  @if (isExternalLink(item)) {
                    <a class="td-wb-mobile-flyout-menu__item"
                       [href]="item.href"
                       [attr.target]="item.target"
                       [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                      <span [innerHTML]="item.text"></span>
                      <td-wb-icon class="td-wb-mobile-flyout-menu-icon--external-link"
                        iconId="new-page"
                        size="16" />
                    </a>
                  }
                  @if (item.type === MenuItemType.CONTACT_NUMBER) {
                    <a class="td-wb-mobile-flyout-menu__item td-wb-mobile-flyout-menu__item--contact-number"
                       [href]="item.href"
                       [attr.target]="item.target"
                       [attr.id]="'td-wb-mobile-flyout-menu__content-item' + item.id">
                      @if (item.title !== undefined && item.title !== null) {
                        <div [innerText]="item.title"></div>
                      }
                      <div class="td-wb-mobile-flyout-menu__item-text--contact-number"
                           [innerText]="item.text"></div>
                    </a>
                  }
                  @if (item.type === MenuItemType.SEPARATOR) {
                    <td-wb-divider class="td-wb-mobile-flyout-menu-divider--sub" />
                  }
                  @if (item.type === MenuItemType.TITLE) {
                    <div
                      [ngClass]="{
                      'td-wb-mobile-flyout-menu__item--title': true,
                      'td-wb-mobile-flyout-menu__item-feedback-title': item.id === 'contact-us-title-give-us-feedback'
                     }"
                      [innerText]="item.title">
                    </div>
                  }
                  @if (item.type === MenuItemType.LINK) {
                    <a class="td-wb-mobile-flyout-menu__item--link"
                       [href]="item.href"
                       [target]="item.target === undefined ? '_self' : item.target"
                       [innerHtml]="item.text">
                    </a>
                  }
                }
              }
            </div>
          </div>
        </ng-template>
      </td-wb-mobile-flyout-menu-nav>
    </td-wb-mobile-flyout-menu>
  </div>
}

<ng-template #customizeMenuTemplate>
  <a [attr.aria-label]="'tdWb.menu.CUSTOMIZE_SITE' | translate"
     href="#/page/preferences/customize-site">
    <td-wb-icon class="td-wb-mobile-flyout-menu__header-icon-container"
                iconId="profile-outline"
                size="50" />
  </a>
  <span id="td-wb-aria-mobile-menu-client-name"
        [innerText]="clientName"></span>

    <a [attr.aria-label]="'tdWb.menu.MY_PROFILE' | translate"
       href="#/page/profile"
       class="td-wb-mobile-flyout-menu__my-profile">
      <span translate="tdWb.menu.MY_PROFILE"></span>
    </a>

</ng-template>

<ng-template #profileMenuTemplate>
  <a [attr.aria-label]="'tdWb.menu.MOBILE_TOP_MENU' | translate"
     href="#/page/profile">
    <td-wb-icon class="td-wb-mobile-flyout-menu__header-icon-container"
                iconId="profile-outline"
                size="50" />
  </a>
  <a [attr.aria-label]="'tdWb.menu.MOBILE_TOP_MENU' | translate"
     href="#/page/profile"
     class="td-wb-mobile-flyout-menu__profile-name">
    <span *tdWbIfNoFeature="'switchGiem'"
          id="td-wb-aria-mobile-menu-client-name"
          [innerText]="clientName"></span>
    <span *tdWbIfFeature="'switchGiem'"
          id="td-wb-aria-mobile-menu-client-name"
          translate="tdWb.menu.MY_PROFILE"></span>
    <td-wb-icon iconId="caret-right--small"
                size="10" />
  </a>
</ng-template>
